module.exports = __webpack_public_path__ + "static/img/biz-license.32e1ae8b.png";